import * as actionTypes from "../../Action/actionTypes";
import {Button as SementicBtn} from "semantic-ui-react";
import React from "react";

/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/11/19
 * Time: 12:12 PM
 */
const initialState = {

  corporate_headers: [
    {
      label: 'Logo',
      field: 'logo',
      sort: 'asc'
    },
    {
      label: 'Corporate Code',
      field: 'code',
      sort: 'asc'
    },
    {
      label: 'Corporate Name',
      field: 'name',
      sort: 'asc'
    },
    {
      label: 'Billing Contact',
      field: 'bill_contact',
      sort: 'asc'
    },
    {
      label: 'Billing Contact Mobile',
      field: 'bill_mob',
      sort: 'asc'
    },
    {
      label: 'Technical Contact',
      field: 'tech_contact',
      sort: 'asc'
    },
    {
      label: 'Technical Contact Mobile',
      field: 'tech_mob',
      sort: 'asc'
    },
    {
      label: 'Added Date and Time',
      field: 'added_datetime',
      sort: 'asc'
    },
    {
      label: 'Added By',
      field: 'added_by',
      sort: 'asc'
    },
    {
      label: 'Last Modified Date and Time',
      field: 'last_mod_datetime',
      sort: 'asc'
    },
    {
      label: 'Last Modified By',
      field: 'last_mod_by',
      sort: 'asc'
    },
    {
      label: 'Contract End Date',
      field: 'contract_enddate',
      sort: 'asc'
    },
    {
      label: 'Status',
      field: 'status',
      sort: 'asc'
    },
    {
      label: 'More Information',
      field: 'more',
      sort: 'asc'
    },
    // {
    //   label: 'Remove',
    //   field: 'remove',
    //   sort: 'asc'
    // },
    // {
    //   label: 'Log',
    //   field: 'more',
    //   sort: 'asc'
    // },
  ],
  view_all_corporates: [
    {
      code: 'C001',
      name: 'Ceyentra',
      bill_contact: 'Tharindu Athukorala',
      bill_mob: '0777879675',
      tech_contact: 'Tharindu Dananjaya',
      tech_mob: '0778533935',
      added_datetime: '2019-07-02 10:51:05',
      added_by: '-',
      last_mod_datetime: '2019-07-03 10:03:58',
      last_mod_by: '-',
      contract_enddate: '2019-10-12',
      status: 'ACTIVE'
    },
    {
      code: 'C002',
      name: 'Dialog Axiata PLC',
      bill_contact: 'Chatura Colombage',
      bill_mob: '0777335467',
      tech_contact: 'Chatura Colombage',
      tech_mob: '0778533935',
      added_datetime: '2019-07-02 10:51:05',
      added_by: '-',
      last_mod_datetime: '2019-07-03 10:03:58',
      last_mod_by: '-',
      contract_enddate: '2019-10-12',
      status: 'INACTIVE'
    }
  ]
};

const reducer = (state = initialState, action) => {
  switch (action.type) {


    case actionTypes.GET_ALL_CORPORATES:
      return {
        ...state,
        view_all_corporates: action.value
      };

    default:
      return state;
  }
};

export default reducer;
